import CardPreview from 'components/messagePreview/components/CardPreview';
import SuggestedActionsPreview from 'components/messagePreview/components/SuggestedActionsPreview';
import { RcsMessage, RcsMessageCard } from 'types/rcs';

interface RcsCardPreviewProps {
  card: RcsMessageCard;
  isLoading: boolean;
  message: RcsMessage;
}

const RcsCardPreview = ({ card, isLoading, message }: RcsCardPreviewProps) => {
  return (
    <>
      <CardPreview
        card={isLoading ? { ...card, text: 'Loading...', title: '' } : card}
      />
      <SuggestedActionsPreview suggestedActions={message.suggestedActions} />
    </>
  );
};

export default RcsCardPreview;
